import { setupDropdownToggle,
    setupDropdownBlur,
    setupDropdownHidden } from './DropdownUtils.js';

const selectors = {
    navbar: '[data-cmp-is="navbar"]',
    navItems: '[data-cmp-hook-navbar="nav-items"]',
    navLink: '[data-cmp-hook-navbar="nav-link"]',
    secondaryNavLink: '[data-cmp-hook-navbar="secondary-nav-link"]',
    tertiaryNavLink: '[data-cmp-hook-navbar="tertiary-nav-link"]',
    dropdown: '[data-cmp-hook-navbar="dropdown"]',
    dropdownSubmenu: '[data-cmp-hook-navbar="dropdown-submenu"]',
    modal: '[data-cmp-is="modal"]',
    toggler: '.navbar-toggler',
    body: 'body'
};

class Navbar {
    constructor(config) {
        this.element = config.element;
        this.init();
    }

    init() {
        if (!this.element) return;
        this.element.removeAttribute('data-cmp-is');
        this.setupDropdownSubmenus();
        this.setActiveNavItem();
        this.updateTabIndex();
        this.setupToggler();
        window.addEventListener('resize', this.updateTabIndex.bind(this));
    }

    setupDropdownSubmenus() {
        setupDropdownToggle(this.element, `${selectors.dropdown} .dropdown-toggle`);
        setupDropdownToggle(this.element, `${selectors.dropdownSubmenu} .dropdown-toggle`);
        setupDropdownBlur(this.element);
        setupDropdownHidden(this.element);
    }

    setActiveNavItem() {
        const currentPath = window.location.pathname.replace(/\/$/, '');
        this.handleSamePathForNavLinks(selectors.navLink, currentPath);
        this.handleSamePathForNavLinks(selectors.secondaryNavLink, currentPath);
        this.handleSamePathForNavLinks(selectors.tertiaryNavLink, currentPath);
    }

    handleSamePathForNavLinks (selector, path) {
        const items = this.element.querySelectorAll(selector);
        items?.forEach(navItem => {
            const navItemHref = new URL(navItem.href).pathname.replace(/\/$/, '');
            if (navItemHref === path) {
                navItem.classList.add('active');
                navItem.setAttribute('aria-current', 'page');
            } else {
                navItem.classList.remove('active');
                navItem.removeAttribute('aria-current');
            }
        });
    }

    updateTabIndex() {
        const navItems = this.element.querySelectorAll(selectors.navLink);
        navItems.forEach(navItem => {
            if (window.innerWidth < 1024) {
                navItem.removeAttribute('tabindex');
            } else {
                navItem.setAttribute('tabindex', '-1');
            }
        });
    }



    setupToggler() {
        const navbarToggler = this.element.querySelector(selectors.toggler);
        const middleLine = document.createElement('div');
        middleLine.classList.add('navbar-toggler-icon', 'middle-line');
        navbarToggler.appendChild(middleLine);

        const bodyTag = document.querySelector(selectors.body);

        if (navbarToggler) {
            navbarToggler.addEventListener('click', function () {
                if (!navbarToggler.classList.contains('collapsed')) {
                    navbarToggler.classList.add('collapsed');
                    bodyTag.classList.add('no-scroll');
                } else {
                    navbarToggler.classList.remove('collapsed');
                    bodyTag.classList.remove('no-scroll');

                }
            });
        }
    }
}
export default Navbar;